<script lang="jsx">
import { computedPbxBasePlans,computedPbxPlans } from '@/common/service/computers/plans/pbx';
import { PBX_GS } from '../helper/constants';
import { mapGetters } from 'vuex';
import Config from './config.vue';
import Edit from './edit.vue';
import Upsell from './upsell.vue';
import BuyTrial from './buy-trial.vue';

export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
    isAddon: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['boughtPlans','getSelectedPlans']),
    hasBoughtPbxBasePlan(){
      return !!computedPbxBasePlans(this.boughtPlans).length;
    },
    isGlobalSelect(){
      return computedPbxPlans(this.getSelectedPlans).some(item => PBX_GS.includes(item.category)) && this.$config('enableZoomPhoneGlobalSelect')
    },
    // Feature flag to enable/disable Zoom Phone Free Trial
    // isZoomPhoneFreeTrialEnabled() {
    //   return this.$config('enableZoomPhoneFreeTrial') !== false;
    // },
  },
  render() {
    const context = { ...this.$attrs, configPlanTileStatus: this.configPlanTileStatus };
    // BUY TRIAL - Zoom Phone Free Trial flow
    // Feature flag check is temporarily disabled, always show BuyTrial for buyTrial flow
    // if (this.$context.is.buyTrial && this.isZoomPhoneFreeTrialEnabled) {
    if (this.$context.is.buyTrial || this.$context.is.add2trial) {
      return <BuyTrial {...context} />;
    }
    if (this.isGlobalSelect && this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <Config {...context} />;
    if (this.$context.is.add2cart || this.$context.is.trial2paid){
      if(this.hasBoughtPbxBasePlan) return <Edit {...context} />;
      return <Config {...context} />;
    }
    if (this.$context.is.upsell) return <Upsell {...context} />;
    return null;
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-pbx {
  &-head {
    align-items: center !important;
    padding-right: 48px;

    .opc-config__collapse {
      padding-right: 12px;
    }

    &__logo {
      flex: 1;
      min-height: 32px;
    }
    &__logo--left {
      flex-shrink: 0;
      align-self: flex-start;

      .opc-pbx__logo, .opc-pbx-regional__logo-icon, .opc-pbx__logo-icon {
        width: 44px;
        height: auto;

        @include media(mobile, tablet) {
          width: 32px;
        }
      }
    }
  }

  &__title-wrapper {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 1.2em;
  }
}

.opc-pbx {
  &__plan {
    &--name {
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 1.2em;
    }
  }

}
</style>
